import { QUERY_KEY_LIST_INSPECTIONS } from '~/features/Inspections/ListInspections'
import { useRefreshList } from '~/shared/ui/ScrollableList'

export const useRefreshPage = () => {
  const { refreshList } = useRefreshList(QUERY_KEY_LIST_INSPECTIONS)

  const refreshPage = async () => {
    await refreshList()
  }

  return { refreshPage }
}
